module.exports = __webpack_public_path__ + "img/Group 55.3b278ef7.png";